import styled from '@emotion/styled';

const UserName = styled('h4')({
  fontWeight: 400
});

export default UserName;
